module.exports = __webpack_public_path__ + "static/img/121.af66236.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/121.png
// module id = wxLx
// module chunks = 0